import { withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-065f2547"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "wrapper-main",
  ref: "md"
}
const _hoisted_2 = { class: "app-component-header__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_add_group_name = _resolveComponent("add-group-name")!
  const _component_add_group_info = _resolveComponent("add-group-info")!
  const _component_add_group_settings = _resolveComponent("add-group-settings")!
  const _component_add_group_members = _resolveComponent("add-group-members")!

  return (_ctx.showDialog)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#popup"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_app_header, { class: "header" }, {
            "top-right": _withCtx(() => [
              (_ctx.currentStep === _ctx.CREATE_STEPS.ADD && _ctx.usersToAdd.length)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    style: _normalizeStyle({ pointerEvents: _ctx.dataLoading }),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addUsersToGroup && _ctx.addUsersToGroup(...args)), ["prevent"])),
                    href: "javascript:void(0);",
                    class: "back-link"
                  }, " Done ", 4))
                : _createCommentVNode("", true),
              (_ctx.currentStep === _ctx.CREATE_STEPS.ADD && !_ctx.usersToAdd.length)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addLater && _ctx.addLater(...args)), ["prevent"])),
                    href: "javascript:void(0);",
                    class: "back-link",
                    style: _normalizeStyle({ pointerEvents: _ctx.dataLoading })
                  }, " Add Later ", 4))
                : _createCommentVNode("", true)
            ]),
            "top-middle": _withCtx(() => [
              _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.stepName), 1)
            ]),
            "top-left": _withCtx(() => [
              (_ctx.currentStep === _ctx.CREATE_STEPS.NAME)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"])),
                    href: "javascript:void(0);",
                    class: "back-link",
                    style: _normalizeStyle({ pointerEvents: _ctx.dataLoading })
                  }, " Cancel ", 4))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "javascript:void(0);",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stepBack && _ctx.stepBack(...args)), ["prevent"])),
                    class: "back-link",
                    style: _normalizeStyle({ pointerEvents: _ctx.dataLoading })
                  }, _hoisted_5, 4))
            ]),
            _: 1
          }),
          (_ctx.currentStep === _ctx.CREATE_STEPS.NAME)
            ? (_openBlock(), _createBlock(_component_add_group_name, {
                key: 0,
                "data-loading": _ctx.dataLoading,
                "error-message": _ctx.errorMessage,
                onOnSetStep: _ctx.setStep
              }, null, 8, ["data-loading", "error-message", "onOnSetStep"]))
            : _createCommentVNode("", true),
          (_ctx.currentStep === _ctx.CREATE_STEPS.INFO)
            ? (_openBlock(), _createBlock(_component_add_group_info, {
                key: 1,
                "data-loading": _ctx.dataLoading,
                onOnSetStep: _ctx.setStep
              }, null, 8, ["data-loading", "onOnSetStep"]))
            : _createCommentVNode("", true),
          (_ctx.currentStep === _ctx.CREATE_STEPS.SETTING)
            ? (_openBlock(), _createBlock(_component_add_group_settings, {
                key: 2,
                "data-loading": _ctx.dataLoading,
                onOnSetStep: _ctx.setStep
              }, null, 8, ["data-loading", "onOnSetStep"]))
            : _createCommentVNode("", true),
          (_ctx.currentStep === _ctx.CREATE_STEPS.ADD)
            ? (_openBlock(), _createBlock(_component_add_group_members, {
                key: 3,
                "users-to-add": _ctx.usersToAdd,
                onUpdateUsers: _ctx.updateUsersToAdd
              }, null, 8, ["users-to-add", "onUpdateUsers"]))
            : _createCommentVNode("", true)
        ], 512)
      ]))
    : _createCommentVNode("", true)
}